// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--react-pdf-text-layer: 1;
	--highlight-bg-color: rgba(180, 0, 170, 1);
	--highlight-selected-bg-color: rgba(0, 100, 0, 1);
}

@media screen and (forced-colors: active) {
	:root {
		--highlight-bg-color: Highlight;
		--highlight-selected-bg-color: ButtonText;
	}
}

[data-main-rotation='90'] {
	transform: rotate(90deg) translateY(-100%);
}
[data-main-rotation='180'] {
	transform: rotate(180deg) translate(-100%, -100%);
}
[data-main-rotation='270'] {
	transform: rotate(270deg) translateX(-100%);
}

.textLayer {
	position: absolute;
	text-align: initial;
	inset: 0;
	overflow: hidden;
	line-height: 1;
	text-size-adjust: none;
	forced-color-adjust: none;
	transform-origin: 0 0;
	z-index: 2;
}

.textLayer :is(span, br) {
	color: transparent;
	position: absolute;
	white-space: pre;
	cursor: text;
	margin: 0;
	transform-origin: 0 0;
}

/* Only necessary in Google Chrome, see issue 14205, and most unfortunately
   * the problem doesn't show up in "text" reference tests. */
.textLayer span.markedContent {
	top: 0;
	height: 0;
}

.textLayer .highlight {
	margin: -1px;
	padding: 1px;
	background-color: var(--highlight-bg-color);
	border-radius: 4px;
}

.textLayer .highlight.appended {
	position: initial;
}

.textLayer .highlight.begin {
	border-radius: 4px 0 0 4px;
}

.textLayer .highlight.end {
	border-radius: 0 4px 4px 0;
}

.textLayer .highlight.middle {
	border-radius: 0;
}

.textLayer .highlight.selected {
	background-color: var(--highlight-selected-bg-color);
}

/* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
.textLayer br::selection {
	background: transparent;
}

.textLayer .endOfContent {
	display: block;
	position: absolute;
	inset: 100% 0 0;
	z-index: -1;
	cursor: default;
	user-select: none;
}

.textLayer .endOfContent.active {
	top: 0;
}

:root {
	--react-pdf-annotation-layer: 1;
	--annotation-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
	--input-focus-border-color: Highlight;
	--input-focus-outline: 1px solid Canvas;
	--input-unfocused-border-color: transparent;
	--input-disabled-border-color: transparent;
	--input-hover-border-color: black;
	--link-outline: none;
}

@media screen and (forced-colors: active) {
	:root {
		--input-focus-border-color: CanvasText;
		--input-unfocused-border-color: ActiveText;
		--input-disabled-border-color: GrayText;
		--input-hover-border-color: Highlight;
		--link-outline: 1.5px solid LinkText;
	}
	.annotationLayer .textWidgetAnnotation :is(input, textarea):required,
	.annotationLayer .choiceWidgetAnnotation select:required,
	.annotationLayer
		.buttonWidgetAnnotation:is(.checkBox, .radioButton)
		input:required {
		outline: 1.5px solid selectedItem;
	}

	.annotationLayer .linkAnnotation:hover {
		backdrop-filter: invert(100%);
	}
}

.annotationLayer {
	position: absolute;
	top: 0;
	left: 0;
	pointer-events: none;
	transform-origin: 0 0;
	z-index: 3;
}

.annotationLayer[data-main-rotation='90'] .norotate {
	transform: rotate(270deg) translateX(-100%);
}
.annotationLayer[data-main-rotation='180'] .norotate {
	transform: rotate(180deg) translate(-100%, -100%);
}
.annotationLayer[data-main-rotation='270'] .norotate {
	transform: rotate(90deg) translateY(-100%);
}

.annotationLayer canvas {
	position: absolute;
	width: 100%;
	height: 100%;
}

.annotationLayer section {
	position: absolute;
	text-align: initial;
	pointer-events: auto;
	box-sizing: border-box;
	margin: 0;
	transform-origin: 0 0;
}

.annotationLayer .linkAnnotation {
	outline: var(--link-outline);
}

.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton) > a {
	position: absolute;
	font-size: 1em;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.annotationLayer
	:is(.linkAnnotation, .buttonWidgetAnnotation.pushButton)
	> a:hover {
	opacity: 0.2;
	background: rgba(255, 255, 0, 1);
	box-shadow: 0 2px 10px rgba(255, 255, 0, 1);
}

.annotationLayer .textAnnotation img {
	position: absolute;
	cursor: pointer;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
}

.annotationLayer .textWidgetAnnotation :is(input, textarea),
.annotationLayer .choiceWidgetAnnotation select,
.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input {
	background-image: var(--annotation-unfocused-field-background);
	border: 2px solid var(--input-unfocused-border-color);
	box-sizing: border-box;
	font: calc(9px * var(--scale-factor)) sans-serif;
	height: 100%;
	margin: 0;
	vertical-align: top;
	width: 100%;
}

.annotationLayer .textWidgetAnnotation :is(input, textarea):required,
.annotationLayer .choiceWidgetAnnotation select:required,
.annotationLayer
	.buttonWidgetAnnotation:is(.checkBox, .radioButton)
	input:required {
	outline: 1.5px solid red;
}

.annotationLayer .choiceWidgetAnnotation select option {
	padding: 0;
}

.annotationLayer .buttonWidgetAnnotation.radioButton input {
	border-radius: 50%;
}

.annotationLayer .textWidgetAnnotation textarea {
	resize: none;
}

.annotationLayer .textWidgetAnnotation :is(input, textarea)[disabled],
.annotationLayer .choiceWidgetAnnotation select[disabled],
.annotationLayer
	.buttonWidgetAnnotation:is(.checkBox, .radioButton)
	input[disabled] {
	background: none;
	border: 2px solid var(--input-disabled-border-color);
	cursor: not-allowed;
}

.annotationLayer .textWidgetAnnotation :is(input, textarea):hover,
.annotationLayer .choiceWidgetAnnotation select:hover,
.annotationLayer
	.buttonWidgetAnnotation:is(.checkBox, .radioButton)
	input:hover {
	border: 2px solid var(--input-hover-border-color);
}
.annotationLayer .textWidgetAnnotation :is(input, textarea):hover,
.annotationLayer .choiceWidgetAnnotation select:hover,
.annotationLayer .buttonWidgetAnnotation.checkBox input:hover {
	border-radius: 2px;
}

.annotationLayer .textWidgetAnnotation :is(input, textarea):focus,
.annotationLayer .choiceWidgetAnnotation select:focus {
	background: none;
	border: 2px solid var(--input-focus-border-color);
	border-radius: 2px;
	outline: var(--input-focus-outline);
}

.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) :focus {
	background-image: none;
	background-color: transparent;
}

.annotationLayer .buttonWidgetAnnotation.checkBox :focus {
	border: 2px solid var(--input-focus-border-color);
	border-radius: 2px;
	outline: var(--input-focus-outline);
}

.annotationLayer .buttonWidgetAnnotation.radioButton :focus {
	border: 2px solid var(--input-focus-border-color);
	outline: var(--input-focus-outline);
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,
.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after,
.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before {
	background-color: CanvasText;
	content: '';
	display: block;
	position: absolute;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,
.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after {
	height: 80%;
	left: 45%;
	width: 1px;
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before {
	transform: rotate(45deg);
}

.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after {
	transform: rotate(-45deg);
}

.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before {
	border-radius: 50%;
	height: 50%;
	left: 30%;
	top: 20%;
	width: 50%;
}

.annotationLayer .textWidgetAnnotation input.comb {
	font-family: monospace;
	padding-left: 2px;
	padding-right: 0;
}

.annotationLayer .textWidgetAnnotation input.comb:focus {
	/*
     * Letter spacing is placed on the right side of each character. Hence, the
     * letter spacing of the last character may be placed outside the visible
     * area, causing horizontal scrolling. We avoid this by extending the width
     * when the element has focus and revert this when it loses focus.
     */
	width: 103%;
}

.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input {
	appearance: none;
}

.annotationLayer .popupTriggerArea {
	height: 100%;
	width: 100%;
}

.annotationLayer .fileAttachmentAnnotation .popupTriggerArea {
	position: absolute;
}

.annotationLayer .popupWrapper {
	position: absolute;
	font-size: calc(9px * var(--scale-factor));
	width: 100%;
	min-width: calc(180px * var(--scale-factor));
	pointer-events: none;
}

.annotationLayer .popup {
	position: absolute;
	max-width: calc(180px * var(--scale-factor));
	background-color: rgba(255, 255, 153, 1);
	box-shadow: 0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor))
		rgba(136, 136, 136, 1);
	border-radius: calc(2px * var(--scale-factor));
	padding: calc(6px * var(--scale-factor));
	margin-left: calc(5px * var(--scale-factor));
	cursor: pointer;
	font: message-box;
	white-space: normal;
	word-wrap: break-word;
	pointer-events: auto;
}

.annotationLayer .popup > * {
	font-size: calc(9px * var(--scale-factor));
}

.annotationLayer .popup h1 {
	display: inline-block;
}

.annotationLayer .popupDate {
	display: inline-block;
	margin-left: calc(5px * var(--scale-factor));
}

.annotationLayer .popupContent {
	border-top: 1px solid rgba(51, 51, 51, 1);
	margin-top: calc(2px * var(--scale-factor));
	padding-top: calc(2px * var(--scale-factor));
}

.annotationLayer .richText > * {
	white-space: pre-wrap;
	font-size: calc(9px * var(--scale-factor));
}

.annotationLayer .highlightAnnotation,
.annotationLayer .underlineAnnotation,
.annotationLayer .squigglyAnnotation,
.annotationLayer .strikeoutAnnotation,
.annotationLayer .freeTextAnnotation,
.annotationLayer .lineAnnotation svg line,
.annotationLayer .squareAnnotation svg rect,
.annotationLayer .circleAnnotation svg ellipse,
.annotationLayer .polylineAnnotation svg polyline,
.annotationLayer .polygonAnnotation svg polygon,
.annotationLayer .caretAnnotation,
.annotationLayer .inkAnnotation svg polyline,
.annotationLayer .stampAnnotation,
.annotationLayer .fileAttachmentAnnotation {
	cursor: pointer;
}

.annotationLayer section svg {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
}

.annotationLayer .annotationTextContent {
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0;
	color: transparent;
	user-select: none;
	pointer-events: none;
}

.annotationLayer .annotationTextContent span {
	width: 100%;
	display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/components/template-editor/pdf-viewer/pdf-viewer.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,0CAA0C;CAC1C,iDAAiD;AAClD;;AAEA;CACC;EACC,+BAA+B;EAC/B,yCAAyC;CAC1C;AACD;;AAEA;CACC,0CAA0C;AAC3C;AACA;CACC,iDAAiD;AAClD;AACA;CACC,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,yBAAyB;CACzB,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,SAAS;CACT,qBAAqB;AACtB;;AAEA;6DAC6D;AAC7D;CACC,MAAM;CACN,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,2CAA2C;CAC3C,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oDAAoD;AACrD;;AAEA,oEAAoE;AACpE;CACC,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,MAAM;AACP;;AAEA;CACC,+BAA+B;CAC/B,+NAA+N;CAC/N,qCAAqC;CACrC,uCAAuC;CACvC,2CAA2C;CAC3C,0CAA0C;CAC1C,iCAAiC;CACjC,oBAAoB;AACrB;;AAEA;CACC;EACC,sCAAsC;EACtC,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,oCAAoC;CACrC;CACA;;;;;EAKC,iCAAiC;CAClC;;CAEA;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,oBAAoB;CACpB,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,2CAA2C;AAC5C;AACA;CACC,iDAAiD;AAClD;AACA;CACC,0CAA0C;AAC3C;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,sBAAsB;CACtB,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;AACb;;AAEA;;;CAGC,YAAY;CACZ,gCAAgC;CAChC,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;AACR;;AAEA;;;CAGC,8DAA8D;CAC9D,qDAAqD;CACrD,sBAAsB;CACtB,gDAAgD;CAChD,YAAY;CACZ,SAAS;CACT,mBAAmB;CACnB,WAAW;AACZ;;AAEA;;;;;CAKC,wBAAwB;AACzB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;;;;;CAKC,gBAAgB;CAChB,oDAAoD;CACpD,mBAAmB;AACpB;;AAEA;;;;;CAKC,iDAAiD;AAClD;AACA;;;CAGC,kBAAkB;AACnB;;AAEA;;CAEC,gBAAgB;CAChB,iDAAiD;CACjD,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA;CACC,iDAAiD;CACjD,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,iDAAiD;CACjD,mCAAmC;AACpC;;AAEA;;;CAGC,4BAA4B;CAC5B,WAAW;CACX,cAAc;CACd,kBAAkB;AACnB;;AAEA;;CAEC,WAAW;CACX,SAAS;CACT,UAAU;AACX;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC;;;;;MAKK;CACL,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,0CAA0C;CAC1C,WAAW;CACX,4CAA4C;CAC5C,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,4CAA4C;CAC5C,wCAAwC;CACxC;wBACuB;CACvB,8CAA8C;CAC9C,wCAAwC;CACxC,4CAA4C;CAC5C,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,4CAA4C;AAC7C;;AAEA;CACC,yCAAyC;CACzC,2CAA2C;CAC3C,4CAA4C;AAC7C;;AAEA;CACC,qBAAqB;CACrB,0CAA0C;AAC3C;;AAEA;;;;;;;;;;;;;;CAcC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,qBAAqB;AACtB","sourcesContent":[":root {\n\t--react-pdf-text-layer: 1;\n\t--highlight-bg-color: rgba(180, 0, 170, 1);\n\t--highlight-selected-bg-color: rgba(0, 100, 0, 1);\n}\n\n@media screen and (forced-colors: active) {\n\t:root {\n\t\t--highlight-bg-color: Highlight;\n\t\t--highlight-selected-bg-color: ButtonText;\n\t}\n}\n\n[data-main-rotation='90'] {\n\ttransform: rotate(90deg) translateY(-100%);\n}\n[data-main-rotation='180'] {\n\ttransform: rotate(180deg) translate(-100%, -100%);\n}\n[data-main-rotation='270'] {\n\ttransform: rotate(270deg) translateX(-100%);\n}\n\n.textLayer {\n\tposition: absolute;\n\ttext-align: initial;\n\tinset: 0;\n\toverflow: hidden;\n\tline-height: 1;\n\ttext-size-adjust: none;\n\tforced-color-adjust: none;\n\ttransform-origin: 0 0;\n\tz-index: 2;\n}\n\n.textLayer :is(span, br) {\n\tcolor: transparent;\n\tposition: absolute;\n\twhite-space: pre;\n\tcursor: text;\n\tmargin: 0;\n\ttransform-origin: 0 0;\n}\n\n/* Only necessary in Google Chrome, see issue 14205, and most unfortunately\n   * the problem doesn't show up in \"text\" reference tests. */\n.textLayer span.markedContent {\n\ttop: 0;\n\theight: 0;\n}\n\n.textLayer .highlight {\n\tmargin: -1px;\n\tpadding: 1px;\n\tbackground-color: var(--highlight-bg-color);\n\tborder-radius: 4px;\n}\n\n.textLayer .highlight.appended {\n\tposition: initial;\n}\n\n.textLayer .highlight.begin {\n\tborder-radius: 4px 0 0 4px;\n}\n\n.textLayer .highlight.end {\n\tborder-radius: 0 4px 4px 0;\n}\n\n.textLayer .highlight.middle {\n\tborder-radius: 0;\n}\n\n.textLayer .highlight.selected {\n\tbackground-color: var(--highlight-selected-bg-color);\n}\n\n/* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */\n.textLayer br::selection {\n\tbackground: transparent;\n}\n\n.textLayer .endOfContent {\n\tdisplay: block;\n\tposition: absolute;\n\tinset: 100% 0 0;\n\tz-index: -1;\n\tcursor: default;\n\tuser-select: none;\n}\n\n.textLayer .endOfContent.active {\n\ttop: 0;\n}\n\n:root {\n\t--react-pdf-annotation-layer: 1;\n\t--annotation-unfocused-field-background: url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\");\n\t--input-focus-border-color: Highlight;\n\t--input-focus-outline: 1px solid Canvas;\n\t--input-unfocused-border-color: transparent;\n\t--input-disabled-border-color: transparent;\n\t--input-hover-border-color: black;\n\t--link-outline: none;\n}\n\n@media screen and (forced-colors: active) {\n\t:root {\n\t\t--input-focus-border-color: CanvasText;\n\t\t--input-unfocused-border-color: ActiveText;\n\t\t--input-disabled-border-color: GrayText;\n\t\t--input-hover-border-color: Highlight;\n\t\t--link-outline: 1.5px solid LinkText;\n\t}\n\t.annotationLayer .textWidgetAnnotation :is(input, textarea):required,\n\t.annotationLayer .choiceWidgetAnnotation select:required,\n\t.annotationLayer\n\t\t.buttonWidgetAnnotation:is(.checkBox, .radioButton)\n\t\tinput:required {\n\t\toutline: 1.5px solid selectedItem;\n\t}\n\n\t.annotationLayer .linkAnnotation:hover {\n\t\tbackdrop-filter: invert(100%);\n\t}\n}\n\n.annotationLayer {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tpointer-events: none;\n\ttransform-origin: 0 0;\n\tz-index: 3;\n}\n\n.annotationLayer[data-main-rotation='90'] .norotate {\n\ttransform: rotate(270deg) translateX(-100%);\n}\n.annotationLayer[data-main-rotation='180'] .norotate {\n\ttransform: rotate(180deg) translate(-100%, -100%);\n}\n.annotationLayer[data-main-rotation='270'] .norotate {\n\ttransform: rotate(90deg) translateY(-100%);\n}\n\n.annotationLayer canvas {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.annotationLayer section {\n\tposition: absolute;\n\ttext-align: initial;\n\tpointer-events: auto;\n\tbox-sizing: border-box;\n\tmargin: 0;\n\ttransform-origin: 0 0;\n}\n\n.annotationLayer .linkAnnotation {\n\toutline: var(--link-outline);\n}\n\n.annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton) > a {\n\tposition: absolute;\n\tfont-size: 1em;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.annotationLayer\n\t:is(.linkAnnotation, .buttonWidgetAnnotation.pushButton)\n\t> a:hover {\n\topacity: 0.2;\n\tbackground: rgba(255, 255, 0, 1);\n\tbox-shadow: 0 2px 10px rgba(255, 255, 0, 1);\n}\n\n.annotationLayer .textAnnotation img {\n\tposition: absolute;\n\tcursor: pointer;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n}\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea),\n.annotationLayer .choiceWidgetAnnotation select,\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input {\n\tbackground-image: var(--annotation-unfocused-field-background);\n\tborder: 2px solid var(--input-unfocused-border-color);\n\tbox-sizing: border-box;\n\tfont: calc(9px * var(--scale-factor)) sans-serif;\n\theight: 100%;\n\tmargin: 0;\n\tvertical-align: top;\n\twidth: 100%;\n}\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):required,\n.annotationLayer .choiceWidgetAnnotation select:required,\n.annotationLayer\n\t.buttonWidgetAnnotation:is(.checkBox, .radioButton)\n\tinput:required {\n\toutline: 1.5px solid red;\n}\n\n.annotationLayer .choiceWidgetAnnotation select option {\n\tpadding: 0;\n}\n\n.annotationLayer .buttonWidgetAnnotation.radioButton input {\n\tborder-radius: 50%;\n}\n\n.annotationLayer .textWidgetAnnotation textarea {\n\tresize: none;\n}\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea)[disabled],\n.annotationLayer .choiceWidgetAnnotation select[disabled],\n.annotationLayer\n\t.buttonWidgetAnnotation:is(.checkBox, .radioButton)\n\tinput[disabled] {\n\tbackground: none;\n\tborder: 2px solid var(--input-disabled-border-color);\n\tcursor: not-allowed;\n}\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):hover,\n.annotationLayer .choiceWidgetAnnotation select:hover,\n.annotationLayer\n\t.buttonWidgetAnnotation:is(.checkBox, .radioButton)\n\tinput:hover {\n\tborder: 2px solid var(--input-hover-border-color);\n}\n.annotationLayer .textWidgetAnnotation :is(input, textarea):hover,\n.annotationLayer .choiceWidgetAnnotation select:hover,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:hover {\n\tborder-radius: 2px;\n}\n\n.annotationLayer .textWidgetAnnotation :is(input, textarea):focus,\n.annotationLayer .choiceWidgetAnnotation select:focus {\n\tbackground: none;\n\tborder: 2px solid var(--input-focus-border-color);\n\tborder-radius: 2px;\n\toutline: var(--input-focus-outline);\n}\n\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) :focus {\n\tbackground-image: none;\n\tbackground-color: transparent;\n}\n\n.annotationLayer .buttonWidgetAnnotation.checkBox :focus {\n\tborder: 2px solid var(--input-focus-border-color);\n\tborder-radius: 2px;\n\toutline: var(--input-focus-outline);\n}\n\n.annotationLayer .buttonWidgetAnnotation.radioButton :focus {\n\tborder: 2px solid var(--input-focus-border-color);\n\toutline: var(--input-focus-outline);\n}\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after,\n.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before {\n\tbackground-color: CanvasText;\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n}\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before,\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after {\n\theight: 80%;\n\tleft: 45%;\n\twidth: 1px;\n}\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::before {\n\ttransform: rotate(45deg);\n}\n\n.annotationLayer .buttonWidgetAnnotation.checkBox input:checked::after {\n\ttransform: rotate(-45deg);\n}\n\n.annotationLayer .buttonWidgetAnnotation.radioButton input:checked::before {\n\tborder-radius: 50%;\n\theight: 50%;\n\tleft: 30%;\n\ttop: 20%;\n\twidth: 50%;\n}\n\n.annotationLayer .textWidgetAnnotation input.comb {\n\tfont-family: monospace;\n\tpadding-left: 2px;\n\tpadding-right: 0;\n}\n\n.annotationLayer .textWidgetAnnotation input.comb:focus {\n\t/*\n     * Letter spacing is placed on the right side of each character. Hence, the\n     * letter spacing of the last character may be placed outside the visible\n     * area, causing horizontal scrolling. We avoid this by extending the width\n     * when the element has focus and revert this when it loses focus.\n     */\n\twidth: 103%;\n}\n\n.annotationLayer .buttonWidgetAnnotation:is(.checkBox, .radioButton) input {\n\tappearance: none;\n}\n\n.annotationLayer .popupTriggerArea {\n\theight: 100%;\n\twidth: 100%;\n}\n\n.annotationLayer .fileAttachmentAnnotation .popupTriggerArea {\n\tposition: absolute;\n}\n\n.annotationLayer .popupWrapper {\n\tposition: absolute;\n\tfont-size: calc(9px * var(--scale-factor));\n\twidth: 100%;\n\tmin-width: calc(180px * var(--scale-factor));\n\tpointer-events: none;\n}\n\n.annotationLayer .popup {\n\tposition: absolute;\n\tmax-width: calc(180px * var(--scale-factor));\n\tbackground-color: rgba(255, 255, 153, 1);\n\tbox-shadow: 0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor))\n\t\trgba(136, 136, 136, 1);\n\tborder-radius: calc(2px * var(--scale-factor));\n\tpadding: calc(6px * var(--scale-factor));\n\tmargin-left: calc(5px * var(--scale-factor));\n\tcursor: pointer;\n\tfont: message-box;\n\twhite-space: normal;\n\tword-wrap: break-word;\n\tpointer-events: auto;\n}\n\n.annotationLayer .popup > * {\n\tfont-size: calc(9px * var(--scale-factor));\n}\n\n.annotationLayer .popup h1 {\n\tdisplay: inline-block;\n}\n\n.annotationLayer .popupDate {\n\tdisplay: inline-block;\n\tmargin-left: calc(5px * var(--scale-factor));\n}\n\n.annotationLayer .popupContent {\n\tborder-top: 1px solid rgba(51, 51, 51, 1);\n\tmargin-top: calc(2px * var(--scale-factor));\n\tpadding-top: calc(2px * var(--scale-factor));\n}\n\n.annotationLayer .richText > * {\n\twhite-space: pre-wrap;\n\tfont-size: calc(9px * var(--scale-factor));\n}\n\n.annotationLayer .highlightAnnotation,\n.annotationLayer .underlineAnnotation,\n.annotationLayer .squigglyAnnotation,\n.annotationLayer .strikeoutAnnotation,\n.annotationLayer .freeTextAnnotation,\n.annotationLayer .lineAnnotation svg line,\n.annotationLayer .squareAnnotation svg rect,\n.annotationLayer .circleAnnotation svg ellipse,\n.annotationLayer .polylineAnnotation svg polyline,\n.annotationLayer .polygonAnnotation svg polygon,\n.annotationLayer .caretAnnotation,\n.annotationLayer .inkAnnotation svg polyline,\n.annotationLayer .stampAnnotation,\n.annotationLayer .fileAttachmentAnnotation {\n\tcursor: pointer;\n}\n\n.annotationLayer section svg {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n}\n\n.annotationLayer .annotationTextContent {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\topacity: 0;\n\tcolor: transparent;\n\tuser-select: none;\n\tpointer-events: none;\n}\n\n.annotationLayer .annotationTextContent span {\n\twidth: 100%;\n\tdisplay: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
